var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container-table"},[_c('div',{staticClass:"container-title"},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_vm._v("mdi-chevron-left")]),_vm._v(" Detalhes da Consulta ")],1),_c('ScheduleDetails',{staticClass:"px-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }